// material
import { styled } from '@mui/material/styles';
import { Box, Card, Container, Typography, Stack } from '@mui/material';
import { useEffect, useState } from 'react';

// components
import Page from '../components/Page';
import { ForgotForm } from 'src/sections/authentication/forgot';
import { get_crm_logo_favicon } from '../ApiServices';

// -----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  },
  backgroundColor: process.env.REACT_APP_BACKGROUND
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 4),
  padding: theme.spacing(5)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 450,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  paddingTop: 43
}));

// ----------------------------------------------------------------------

export default function Forgot() {
  const [crmLogo, setCrmLogo] = useState(null);
  useEffect(() => {
    const fetchCrmAssets = async () => {
      try {
        const res = await get_crm_logo_favicon();

        if (res?.data?.length) {
          const logo = res.data.find((item) => item.key === 'crm_logo');
          if (logo?.value) {
            setCrmLogo(logo.value);
          }
        }
      } catch (error) {
        console.error('Failed to load CRM logo:', error);
      }
    };

    fetchCrmAssets();
  }, []);
  return (
    <RootStyle title={`Forgot | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
            <Box
              component="img"
              // src={process.env.REACT_APP_LOGIN}
              src={crmLogo || process.env.REACT_APP_LOGIN}
              sx={{
                padding: 1,
                marginLeft: 1,
                width: 200,
                height: 90
              }}
            />

            <Typography sx={{ fontSize: 25, fontFamily: 'poppinsBold' }}>
              Forgot password?
            </Typography>
          </Stack>

          <ForgotForm />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
